
import { MEMBERS_PORTAL } from "../../../../accounts/Consts";
import { DRAFT_AGREEMENTS_COMMENTS_STATE_KEY, DRAFT_AGREEMENT_ASSIGNEE_VIEW, EMPTY_STRING_VALUE } from "../../../../membersportal/Consts";
import { IDistributionPoolState } from "../../../../redux/types/IDistributionPoolState";
import { IPaymentRunDistributionState } from "../../../../redux/types/IPaymentRunDistributionState";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { WORK_NAME_LOOKUP, LANGUAGE_LOOKUP, WORK_NUMBER_LOOKUP, COMMENT_CATEGORY_LOOKUP, SOCIETY_OF_LICENSE_LOOKUP, SET_TYPE_LOOKUP, SET_TYPE_GROUP_LOOKUP, WORK_SOURCE_LOOKUP, TERRITORY_LOOKUP, WORK_CONTRIBUTOR_TYPE_LOOKUP, WORK_CONTRIBUTOR_SUB_TYPE_LOOKUP, WORK_PERFORMER_LOOKUP, APPLICABLE_WORKS_LOOKUP, AGREEMENT_RETAINED_UNTIL_LOOKUP, AGREEMENT_RETENTION_LOOKUP, AGREEMENT_NUMBER_TYPE_LOOKUP, PRODUCT_NAME_TYPE_LOOKUP, PRODUCT_NUMBER_TYPE_LOOKUP, PRODUCT_STATUS_LOOKUP, INSTRUMENTATION_LOOKUP, WORK_PERFORMER_NUMBER_LOOKUP, USAGE_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { getLookupDefault } from "../../../../lookup/services/LookupHelpers";
import { DROPDOWN_INPUT, TEXT_INPUT, DATE_INPUT, READ_ONLY_INPUT, INTEGER_INPUT, INTEGER_PERCENTAGE_INPUT, TEXT_READONLY_IN_REPERTOIRE_INPUT, BOOLEAN_READONLY_INPUT, CHECKBOX_INPUT, TIMESPAN_INPUT, CUSTOM_INPUT, DROPDOWN_TREE_INPUT, TIME_INPUT, POOL_AMOUNT_MULTIPLIERS_KEY, USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY, USAGE_MAINTENANCE_COMMENTS_MODAL, COMMENTS_VIEW, CONTRIBUTOR_COMMENTS_VIEW, FOREIGN_SOCIETY_INFO_VIEW, MATCHING_WORK_MORE_INFO_VIEW, SELECTION_CRITERIA_VIEW, WORK_NOT_FOUND_VIEW } from "../../../Consts";
import { showModal } from "../../../../redux/reducers/ModalReducer";
import { createCopyOfTableContents } from "../../../services/TableFunctions";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";

type ShowModalAsVoid = (...args: Parameters<typeof showModal>) => void;

export const openModalOrNewTab = (componentInstance: string, tableContentItem: any, fieldName: string, showModal: ShowModalAsVoid, openInNewTab: (item: any) => void, isReadOnly = false) => {
    switch (componentInstance) {
        case USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY:
            showModal(USAGE_MAINTENANCE_COMMENTS_MODAL, null, tableContentItem, true, "Comment Details");
            break;
        case "comments":
            showModal(COMMENTS_VIEW, null, tableContentItem, true, "Comment Details");
            break;
        case "distributionPools":
            if (fieldName === "Selection Criteria")
                showModal(SELECTION_CRITERIA_VIEW, null, tableContentItem, true, "Selection Criteria", undefined, isReadOnly);
            else if (fieldName === "Currency and Deductions")
                showModal(FOREIGN_SOCIETY_INFO_VIEW, null, tableContentItem, true, "Currency and Deductions", undefined, (tableContentItem.status.value === "Allocated"));
            break;
        case "matchingRepertoireWorks":
            if (tableContentItem['repertoireWorkID'] <= 0) {
                showModal(WORK_NOT_FOUND_VIEW, null, null, true, "Work Not Selected");
            } else {
                showModal(MATCHING_WORK_MORE_INFO_VIEW, null, tableContentItem['repertoireWorkID'], true, "Work Information");
            }
            break;
        case "contributors":
            if (fieldName === "Comment") {
                showModal(CONTRIBUTOR_COMMENTS_VIEW, null, tableContentItem, true, "Comment Details");
            }
            break;
        case "paymentRunDistributions":
            openInNewTab(tableContentItem.distributionID);
            break;
        default:
            break;
    }
};

export const removeTableItem = (
    changeData: (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => void,
    stateKey: string, tableContents: any[], tabs: ITabReduxItem[], activeTab: number, componentInstance: string, ipRepresentationsIdsToRemove: number[], tableContentItem: any
) => {
    const tableContentsCopy = createCopyOfTableContents(tableContents);
    if (activeTab) {
        ipRepresentationsIdsToRemove = tabs[activeTab].interestedPartyMaintenanceState?.representationIds ?? []
    }
    else {
        ipRepresentationsIdsToRemove = []
    }
    let indexToDelete = tableContentsCopy.indexOf(tableContentItem);
    if (componentInstance === "numbers"){
        indexToDelete = tableContentsCopy.findIndex(item => item.workNumberID === tableContentItem.workNumberID);
    }

    if (indexToDelete > -1) {
        tableContentsCopy.splice(indexToDelete, 1);
    }
    changeData(tableContentsCopy, stateKey, null, ipRepresentationsIdsToRemove);
};

export const getNewItem = (
    componentInstance: string, 
    nextTempID: number, 
    currentUser: String, 
    portalType: string, 
    lookupValues: ILookupDictionary, 
    activeSetType: string, 
    setTypeGroup: string
): Record<string, any> => {
    let newItem: Record<string, any> = null;

    switch (componentInstance) {
        case "titles":
            {
                newItem =
                {
                    type:
                    {
                        value: getLookupDefault(WORK_NAME_LOOKUP, lookupValues),
                        inputType: DROPDOWN_INPUT
                    },
                    language:
                    {
                        value: getLookupDefault(LANGUAGE_LOOKUP, lookupValues),
                        inputType: DROPDOWN_INPUT
                    },
                    title:
                    {
                        value: "",
                        inputType: TEXT_INPUT
                    },
                    workNameID: nextTempID
                };
                break;
            };
        case "subjects":
            {
                newItem =
                {
                    startDate:
                    {
                        value: "",
                        inputType: DATE_INPUT,
                    },
                    endDate:
                    {
                        value: "",
                        inputType: DATE_INPUT,
                    },
                    subject:
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT,
                    },
                    percentage:
                    {
                        value: 0,
                        inputType: INTEGER_INPUT,
                    },
                    SubjectID: nextTempID
                };
                break;
            };
        case "workPrice":
            {
                newItem = {
                    startDate:
                    {
                        value: null,
                        inputType: DATE_INPUT
                    },
                    endDate:
                    {
                        value: null,
                        inputType: DATE_INPUT
                    },
                    price:
                    {
                        value: 0,
                        inputType: INTEGER_INPUT,
                    },
                    publisherPrice: {
                        value: 0,
                        inputType: INTEGER_INPUT,
                    },
                    workPriceID: nextTempID
                }
                break;
            }
        case "numbers":
            {
                newItem =
                {
                    type:
                    {
                        value: getLookupDefault(WORK_NUMBER_LOOKUP, lookupValues),
                        inputType: DROPDOWN_INPUT
                    },
                    number:
                    {
                        value: "",
                        inputType: TEXT_INPUT
                    },
                    workNumberID: nextTempID
                };
                break;
            };
        case "additionalNumbers":
            {
                newItem =
                {
                    type:
                    {
                        value: getLookupDefault(WORK_NUMBER_LOOKUP, lookupValues),
                        inputType: DROPDOWN_INPUT
                    },
                    numberAdditional:
                    {
                        value: "",
                        inputType: TEXT_INPUT
                    },
                    workNumberAdditionalID: nextTempID,
                    isDeleted: false
                };
                break;
            };
        case "comments": {
            newItem = {
                user: {
                    value: currentUser
                },
                date: {
                    value: ""
                },
                subject: {
                    value: "",
                    inputType: TEXT_INPUT
                },
                comment: {
                    value: "",
                    inputType: TEXT_INPUT
                },
                commentCategory: {
                    value: getLookupDefault(COMMENT_CATEGORY_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                isModified: true,
                notesID: nextTempID,
            };

            break;
        };
        case "contributors": {
            newItem = {
                workContributorID: nextTempID,
                accountNumber: { value: "", inputType: READ_ONLY_INPUT },
                ipiNumber:
                {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                mechPercentage:
                {
                    value: 0,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                name:
                {
                    value: "",
                    inputType: portalType === MEMBERS_PORTAL ? TEXT_INPUT : READ_ONLY_INPUT
                },
                percentageOfPub:
                {
                    value: "",
                    inputType: TEXT_INPUT
                },
                perfPercentage:
                {
                    value: 0,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                regDate:
                {
                    value: null,
                    inputType: DATE_INPUT
                },
                societyOfLicense: {
                    value: getLookupDefault(SOCIETY_OF_LICENSE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                relation:
                {
                    value: "",
                    inputType: TEXT_INPUT
                },
                reference:
                {
                    value: "",
                    inputType: TEXT_INPUT
                },
                setType: activeSetType ? activeSetType : getLookupDefault(SET_TYPE_LOOKUP, lookupValues),
                setTypeGroup: setTypeGroup ? setTypeGroup : getLookupDefault(SET_TYPE_GROUP_LOOKUP, lookupValues),
                source:
                {
                    value: getLookupDefault(WORK_SOURCE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                territory:
                {
                    value: getLookupDefault(TERRITORY_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                role:
                {
                    value: getLookupDefault(WORK_CONTRIBUTOR_TYPE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                subType:
                {
                    value: getLookupDefault(WORK_CONTRIBUTOR_SUB_TYPE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                senderRep:
                {
                    value: null,
                    inputType: DROPDOWN_INPUT
                },
                agreementChain: [],
                sourceIP: null,
                sourceType: "",
                sourceSociety: "",
                mechSocietyAffiliation: EMPTY_STRING_VALUE,
                perfSocietyAffiliation: EMPTY_STRING_VALUE,
                performingShareToDisplay: {
                    value: '0',
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                mechanicalShareToDisplay: {
                    value: '0',
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                copyLevyPercentage: {
                    value: '0',
                    inputType: INTEGER_INPUT
                },
                copyLicencePercentage: {
                    value: '0',
                    inputType: INTEGER_INPUT
                }
            };
            if (activeSetType === 'other') {
                newItem.includeTerritories = { value: "", inputType: TEXT_INPUT }
                newItem.excludeTerritories = { value: "", inputType: TEXT_INPUT }
            }

            break;
        };
        case "artists": {
            newItem = {
                workPerformerID: nextTempID,
                type:
                {
                    value: getLookupDefault(WORK_PERFORMER_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                firstName:
                {
                    value: "",
                    inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT
                },
                lastName:
                {
                    value: "",
                    inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT
                },
                fullName:
                {
                    value: "",
                    inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT,
                },
                number:
                {
                    value: "",
                    inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT,
                }
            };
            break;
        };
        case "workEdition": {
            newItem = {
                workEditionID: nextTempID,
                yearOfEdition:
                {
                    value: "",
                    inputType: INTEGER_INPUT
                },
                completationEditionDate:
                {
                    value: "",
                    inputType: DATE_INPUT
                },
                editionNumber:
                {
                    value: "",
                    inputType: TEXT_INPUT
                },
                dateOfPrinting:
                {
                    value: "",
                    inputType: DATE_INPUT
                },
                numberOfPrinting:
                {
                    value: "",
                    inputType: INTEGER_INPUT,
                },
                numberOfCopiesInCirculation:
                {
                    value: "",
                    inputType: INTEGER_INPUT,
                },
                editionOrigin:
                {
                    value: "",
                    inputType: TEXT_INPUT,
                },
                createdDate:
                {
                    value: new Date(),
                    inputType: DATE_INPUT
                },
                lastModifiedBy:
                {
                    value: 0,
                    inputType: INTEGER_INPUT
                },
                lastModifiedDate:
                {
                    value: new Date(),
                    inputType: DATE_INPUT
                },
                workID: 0,
                isDeleted:
                {
                    value: false,
                    inputType: BOOLEAN_READONLY_INPUT
                }

            };
            break;
        };
        case "administeredBy": {
            newItem = {
                agreementAdminIPID: nextTempID,
                administeredByIPBaseNumber: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                accountNumber: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                administeredName: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                administeredIP: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                performingShare: {
                    value: 100,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                creatorRetainedPerShare: {
                    value: 0,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                publisherRetainedPerShare: {
                    value: 0,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                mechanicalShare: {
                    value: 100,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                creatorRetainedMechShare: {
                    value: 0,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                publisherRetainedMechShare: {
                    value: 0,
                    inputType: INTEGER_PERCENTAGE_INPUT
                },
                performingShareToDisplay: {
                    value: '100',
                    inputType: INTEGER_INPUT
                },
                mechanicalShareToDisplay: {
                    value: '100',
                    inputType: INTEGER_INPUT
                }
            };
            break;
        };
        case "applicableWorks": {
            newItem = {
                agreementWorkID: nextTempID,
                workName: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                workNumber: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                type: {
                    value: getLookupDefault(APPLICABLE_WORKS_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                exclusionUntil: {
                    value: getLookupDefault(AGREEMENT_RETAINED_UNTIL_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                excludedUntilDate: {
                    value: null,
                    inputType: DATE_INPUT
                },
                worksRetainedUntil: {
                    value: getLookupDefault(AGREEMENT_RETAINED_UNTIL_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                workRetentionEndDate: {
                    value: null,
                    inputType: DATE_INPUT
                },
                useDefaultCollection: {
                    value: getLookupDefault(AGREEMENT_RETENTION_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                workCollectionUntil: {
                    value: getLookupDefault(AGREEMENT_RETAINED_UNTIL_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                workCollectionEndDate: {
                    value: null,
                    inputType: DATE_INPUT
                }
            };
            break;
        };
        case "agreementCarveOuts": {
            newItem = {
                agreementProductWorkID: nextTempID,
                productName: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                productNumber: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                workName: {
                    value: "",
                    inputType: DROPDOWN_INPUT
                },
                workNumber: {
                    value: "",
                    inputType: READ_ONLY_INPUT
                },
                workId: null
            };
            break;
        };
        case "agreementNumbers": {
            newItem = {
                agreementNumberID: nextTempID,
                number: {
                    value: "",
                    inputType: TEXT_INPUT
                },
                numberType: {
                    value: getLookupDefault(AGREEMENT_NUMBER_TYPE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                }
            };
            break;
        };
        case "productName": {
            newItem = {
                productNameID: nextTempID,
                name: {
                    value: "",
                    inputType: TEXT_INPUT
                },
                productNameType: {
                    value: getLookupDefault(PRODUCT_NAME_TYPE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                language: {
                    value: getLookupDefault(LANGUAGE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                }
            };
            break;
        };
        case "productNumber": {
            newItem = {
                productNumberID: nextTempID,
                number: {
                    value: "",
                    inputType: TEXT_INPUT
                },
                productNumberType: {
                    value: getLookupDefault(PRODUCT_NUMBER_TYPE_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                status: {
                    value: getLookupDefault(PRODUCT_STATUS_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                }
            };
            break;
        };
        case "productPerformer": {
            newItem = {
                productPerformerID: nextTempID,
                performerName: {
                    value: "",
                    inputType: TEXT_INPUT
                },
                type: {
                    value: getLookupDefault(WORK_PERFORMER_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                }
            };
            break;
        };
        case "licensesAndProducts": {
            newItem = {
                workProductID: nextTempID,
                title: { value: "", inputType: READ_ONLY_INPUT },
                number: { value: "", inputType: READ_ONLY_INPUT },
                contributors: { value: "", inputType: READ_ONLY_INPUT },
                artists: { value: "", inputType: READ_ONLY_INPUT },
                intrayIndicator: { value: "", inputType: BOOLEAN_READONLY_INPUT },
            };
            break;
        };
        case "workPaymentRuns": {
            newItem = {
                paymentRun: { value: "", inputType: READ_ONLY_INPUT },
                distibution: { value: "", inputType: READ_ONLY_INPUT },
                pool: { value: "", inputType: READ_ONLY_INPUT },
                amount: { value: "", inputType: READ_ONLY_INPUT },
                segment: { value: "", inputType: READ_ONLY_INPUT },
                date: { value: "", inputType: READ_ONLY_INPUT }
            };
            break;
        };
        case "matchingRepertoireWorks": {
            newItem = {
                workID: nextTempID,
                repertoireWorkID: -1,
                name: [
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    }
                ],
                number: [
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    }
                ],
                publisher: [
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    }
                ],
                writer: [
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    }
                ],
                artist: [
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    }
                ],
                isDefinite: {
                    value: false,
                    inputType: CHECKBOX_INPUT
                }
            };
            break;
        };
        case "matchingRepertoireProducts": {
            newItem = {
                productID: nextTempID,
                repertoireProductID: -1,
                name: [
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    }
                ],
                number: [
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    },
                    {
                        value: "",
                        inputType: READ_ONLY_INPUT
                    }
                ],
                isDefinite: {
                    value: false,
                    inputType: CHECKBOX_INPUT
                }
            }
            break;
        };
        case "productAVWork": {
            newItem = {
                productAVWorkID: nextTempID,
                territory: { value: "", inputType: DROPDOWN_INPUT },
                category: { value: "", inputType: DROPDOWN_INPUT },
                seriesIdentifier: { value: "", inputType: TEXT_INPUT },
                productionNumber: { value: "", inputType: TEXT_INPUT },
                episodeNumber: { value: "", inputType: TEXT_INPUT },
                yearOfProduction: { value: "", inputType: INTEGER_INPUT },
                totalDuration: { value: "", inputType: TIMESPAN_INPUT },
                musicDuration: { value: "", inputType: TIMESPAN_INPUT },
                airDate: { value: null, inputType: DATE_INPUT },
                airedUntil: { value: null, inputType: DATE_INPUT },
                type: { value: "", inputType: DROPDOWN_INPUT },
                cueSheetType: { value: "", inputType: DROPDOWN_INPUT },
                destination: { value: "", inputType: DROPDOWN_INPUT },
                countryOfOrigin: { value: "", inputType: DROPDOWN_INPUT },
                codeOfRevision: { value: "", inputType: DROPDOWN_INPUT },
                dateOfRevision: { value: null, inputType: DATE_INPUT },
                vIsan: { value: "", inputType: TEXT_INPUT },
            };
            break;
        };
        case "productContributor": {
            newItem = {
                productContributorID: nextTempID,
                name: { value: "", inputType: TEXT_INPUT },
                avRipRoleCode: { value: "", inputType: DROPDOWN_INPUT }
            };
            break;
        }
        case "instrumentation": {
            newItem = {
                instrumentationID: nextTempID,
                type: { value: getLookupDefault(INSTRUMENTATION_LOOKUP, lookupValues), inputType: DROPDOWN_INPUT },
                description: { value: "", inputType: CUSTOM_INPUT },
                workInstruments: []
            };
            break;
        }
        case "artistNumbers": {
            newItem = {
                performerNumberID: nextTempID,
                number: { value: "", inputType: TEXT_INPUT },
                numberType: { value: getLookupDefault(WORK_PERFORMER_NUMBER_LOOKUP, lookupValues), inputType: DROPDOWN_INPUT }
            };
            break;
        }
        case "poolSources": {
            newItem = {
                poolSourceID: nextTempID,
                usageType: { value: getLookupDefault(USAGE_TYPE_LOOKUP, lookupValues), inputType: DROPDOWN_INPUT },
                source: { value: null, inputType: DROPDOWN_TREE_INPUT },
                hierarchy: { value: "", inputType: READ_ONLY_INPUT }
            }
            break;
        }
        case "poolRightTypes": {
            newItem = {
                poolRightID: nextTempID,
                shareSet: { value: '', inputType: DROPDOWN_INPUT },
                economicRights: { value: '', inputType: DROPDOWN_INPUT },
                economicRightDescription: { value: '', inputType: READ_ONLY_INPUT }
            }
            break;
        }
        case "distributionPools": {
            let distPoolState: IDistributionPoolState = {
                distributionPoolID: nextTempID,
                poolCode: { value: null, inputType: DROPDOWN_INPUT },
                description: { value: "", inputType: READ_ONLY_INPUT },
                status: { value: "Not Allocated", inputType: READ_ONLY_INPUT },
                segment: { value: "", inputType: TEXT_INPUT },
                amountToAllocate: { value: 0, inputType: INTEGER_INPUT },
                amountAllocated: { value: 0, inputType: READ_ONLY_INPUT },
                actualValuePerPoint: { value: 0, inputType: READ_ONLY_INPUT },
                nominalValuePerPoint: { value: null, inputType: INTEGER_INPUT },
                allocationRule: { value: "", inputType: READ_ONLY_INPUT },
                selectionCriteria: { type: "All" },
                selected: { value: false, inputType: CHECKBOX_INPUT },
                exchangeRate: { value: 1, inputType: INTEGER_INPUT },
                witholdingTaxAgreement: { value: 0, inputType: INTEGER_INPUT },
                witholdingTaxNoAgreement: { value: 0, inputType: INTEGER_INPUT },
                socialAndCulturalDeduction: { value: 0, inputType: INTEGER_INPUT },
                bankCharges: { value: 0, inputType: INTEGER_INPUT },
                adminFees: { value: 0, inputType: INTEGER_INPUT },
                currency: { value: "", inputType: TEXT_INPUT },
                otherAdditions: { value: 0, inputType: INTEGER_INPUT },
                otherDeductions: { value: 0, inputType: INTEGER_INPUT },
                narrative: { value: "", inputType: TEXT_INPUT },
                tdpsvAllocated: { value: null, inputType: READ_ONLY_INPUT },
                tdpsvError: { value: null, inputType: READ_ONLY_INPUT },
                tdpsvUa: { value: null, inputType: READ_ONLY_INPUT },
                tdpsvUu: { value: null, inputType: READ_ONLY_INPUT },
                poolID: null,
                continuallyDistribute: { value: false, inputType: CHECKBOX_INPUT },
                adjustments: { value: false, inputType: CHECKBOX_INPUT },
                qaStatus: { value: "Not Ran", inputType: READ_ONLY_INPUT },
                preAllocationStatus: { value: false, inputType: READ_ONLY_INPUT },
                cdStatus: { value: false, inputType: READ_ONLY_INPUT }
            }
            newItem = distPoolState;
            break;
        }
        case "paymentRunDistributions": {
            let paymentRunDistributionState: IPaymentRunDistributionState = {
                paymentRunDistributionID: nextTempID,
                distributionCode: { value: null, inputType: DROPDOWN_INPUT },
                distributionID: null,
                paymentRunID: 0,
                status: { value: "", inputType: READ_ONLY_INPUT },
                cat1: { value: "", inputType: READ_ONLY_INPUT },
                cat2: { value: "", inputType: READ_ONLY_INPUT },
                description: { value: "", inputType: READ_ONLY_INPUT },
                year: { value: "", inputType: READ_ONLY_INPUT },
            }
            newItem = paymentRunDistributionState;
            break;
        }
        case "SelectionCriteria": {
            newItem = {
                distPoolSegmentID: nextTempID,
                distribution: { value: null, inputType: DROPDOWN_INPUT },
                pool: { value: null, inputType: DROPDOWN_INPUT },
                segment: { value: null, inputType: DROPDOWN_INPUT },
            }
            break;
        }
        case "DateRangeSelectionCriteria": {
            newItem = {
                dateRangeSegmentID: nextTempID,
                fromDate: { value: null, inputType: DATE_INPUT },
                toDate: { value: null, inputType: DATE_INPUT }
            }
            break;
        }
        case "productWorkSearch": {
            newItem = {
                title: {
                    value: '',
                    inputType: TEXT_INPUT
                },
                number: {
                    value: '',
                    inputType: READ_ONLY_INPUT
                },
                writer: {
                    value: '',
                    inputType: TEXT_INPUT
                },
                artist: {
                    value: '',
                    inputType: TEXT_INPUT
                },
                status: {
                    value: 'Draft',
                    inputType: READ_ONLY_INPUT
                },
                duration: {
                    value: 0,
                    inputType: INTEGER_INPUT
                },
                intrayIndicator: {
                    value: portalType === MEMBERS_PORTAL ? true : undefined
                },
                remove: {
                    value: '',
                    inputType: TEXT_INPUT
                },
            }
            break;
        }
        case "moreDates": {
            newItem = {
                usageDate: {
                    value: '',
                    inputType: DATE_INPUT
                },
                programStartDate: {
                    value: '',
                    inputType: TIME_INPUT
                },
                programEndDate: {
                    value: '',
                    inputType: TIME_INPUT
                }
            }
            break;
        }
        case POOL_AMOUNT_MULTIPLIERS_KEY: {
            newItem = {
                effectiveFrom: { value: "", inputType: DATE_INPUT },
                effectiveTo: { value: "", inputType: DATE_INPUT },
                amountMultiplier: { value: "", inputType: TEXT_INPUT },
            }
            break;
        }
        case "poolEstimatedValuePerPointSettings": {
            newItem = {
                effectiveFrom: { value: "", inputType: DATE_INPUT },
                effectiveTo: { value: "", inputType: DATE_INPUT },
                evpp: { value: "", inputType: TEXT_INPUT },
            }
            break;
        }
        case "ipRepresentation": {
            newItem = {
                societyName: { value: "", inputType: DROPDOWN_INPUT },
                fromDate: { value: new Date().toISOString().split('T', 1)[0], inputType: DATE_INPUT },
                toDate: { value: new Date('9999-12-31').toISOString().split('T', 1)[0], inputType: DATE_INPUT },
                economicRights: { value: "", inputType: DROPDOWN_INPUT },
                shareSet: { value: "", inputType: READ_ONLY_INPUT },
                role: { value: "", inputType: DROPDOWN_INPUT },
                includeTerritories: { value: "2WL", inputType: TEXT_INPUT },
                excludeTerritories: { value: "", inputType: TEXT_INPUT },
                includePools: { value: "ALL", inputType: TEXT_INPUT },
                excludePools: { value: "", inputType: TEXT_INPUT },
                creationClass: { value: "", inputType: DROPDOWN_INPUT },
            }
            break;
        }
        case DRAFT_AGREEMENTS_COMMENTS_STATE_KEY: {
            let formattedToday = new Date().toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(',', '');
            newItem = {
                date: { value: formattedToday, inputType: READ_ONLY_INPUT },
                subject: { value: "", inputType: TEXT_INPUT },
                commentCategory: {
                    value: getLookupDefault(COMMENT_CATEGORY_LOOKUP, lookupValues),
                    inputType: DROPDOWN_INPUT
                },
                comment: { value: "", inputType: TEXT_INPUT },
            }
            break;
        }
        case USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY: {
            let formattedToday = new Date().toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(',', '');
            newItem = {
                date: { value: formattedToday, inputType: READ_ONLY_INPUT },
                subject: { value: "", inputType: TEXT_INPUT },
                comment: { value: "", inputType: TEXT_INPUT },
            }
            break;
        }
        case DRAFT_AGREEMENT_ASSIGNEE_VIEW: {
            newItem = {
                assigneeNameNumber: { value: "", inputType: READ_ONLY_INPUT },
                assigneeName: { value: "", inputType: READ_ONLY_INPUT },
                societyAffiliation: { value: "", inputType: READ_ONLY_INPUT },
                performingShare: { value: 0, inputType: INTEGER_PERCENTAGE_INPUT },
                creatorRetainedPerShare: { value: 0, inputType: INTEGER_PERCENTAGE_INPUT },
                publisherRetainedPerShare: { value: 0, inputType: INTEGER_PERCENTAGE_INPUT },
                mechanicalShare: { value: 0, inputType: INTEGER_PERCENTAGE_INPUT },
                creatorRetainedMechShare: { value: 0, inputType: INTEGER_PERCENTAGE_INPUT },
                publisherRetainedMechShare: { value: 0, inputType: INTEGER_PERCENTAGE_INPUT },
            }
            break;
        }
        case "draftAgreementsApplicableWorks": {
            newItem = {
                workName: { value: "", inputType: TEXT_INPUT },
                workNumber: { value: "", inputType: TEXT_INPUT },
            }
            break;
        }
        default:
            {
                newItem = null;
                break;
            }
    }

    return newItem;
}